import { createGlobalStyle } from 'styled-components';

/*
 * IEMENTech 2027 — "Copper & Silicon" design system (Light)
 * Warm parchment surfaces · graphite-silver bezels · copper accent
 */
const GlobalStyles = createGlobalStyle`
  :root {
    /* Surfaces */
    --bg: #ece9e1;
    --bg-elev: #e3dfd4;
    --bg-card: #ffffff;
    --bg-card-hover: #f7f4ec;

    /* Ink */
    --ink: #221f1a;
    --ink-dim: #5a5449;
    --ink-faint: #8d8678;

    /* Accent — copper (deepened so it stays legible on light) */
    --copper: #b3641a;
    --copper-bright: #cf7d1f;
    --copper-deep: #8a4a12;
    --copper-glow: rgba(201, 117, 26, 0.16);

    /* Accent — plasma (live / status only) */
    --plasma: #0f897a;

    /* Lines */
    --line: rgba(34, 31, 26, 0.12);
    --line-strong: rgba(34, 31, 26, 0.22);

    /* Type */
    --font-display: 'Syne', 'Instrument Sans', sans-serif;
    --font-body: 'Instrument Sans', -apple-system, 'Segoe UI', sans-serif;
    --font-mono: 'IBM Plex Mono', 'Courier New', monospace;

    /* Rhythm */
    --section-pad: clamp(4.5rem, 9vw, 8.5rem);
    --container: 1240px;
    --radius: 14px;
    --radius-sm: 8px;

    /* Motion */
    --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    /* clip (not hidden) kills sideways slide on mobile without breaking position: sticky */
    overflow-x: clip;
  }

  body {
    font-family: var(--font-body);
    background: var(--bg);
    color: var(--ink);
    line-height: 1.65;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    overflow-x: clip;
  }

  ::selection {
    background: var(--copper);
    color: var(--bg);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-display);
    color: var(--ink);
    line-height: 1.08;
    font-weight: 700;
    letter-spacing: -0.015em;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  :focus-visible {
    outline: 2px solid var(--copper);
    outline-offset: 3px;
    border-radius: 2px;
  }

  /* Custom scrollbar — graphite + copper */
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: var(--bg);
  }
  ::-webkit-scrollbar-thumb {
    background: #c2bcb0;
    border-radius: 5px;
    border: 2px solid var(--bg);
  }
  ::-webkit-scrollbar-thumb:hover {
    background: var(--copper-deep);
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyles;
